import React from "react";
import { clsx } from "clsx";
import { Card } from "../Card";

export interface KpiCardProps extends React.HTMLAttributes<HTMLDivElement> {
    label: string;
    value: React.ReactNode;
    hint?: string;
    accent?: "primary" | "gold" | "success" | "warning" | "danger";
}

const accentBar: Record<NonNullable<KpiCardProps["accent"]>, string> = {
    primary: "bg-primary",
    gold: "bg-gold",
    success: "bg-success",
    warning: "bg-warning",
    danger: "bg-danger",
};

export const KpiCard: React.FC<KpiCardProps> = ({
    label,
    value,
    hint,
    accent = "primary",
    className,
    ...props
}) => (
    <Card className={clsx("relative overflow-hidden", className)} {...props}>
        <span className={clsx("absolute inset-y-0 start-0 w-1", accentBar[accent])} aria-hidden />
        <p className="text-xs font-medium uppercase tracking-wide text-neutral-secondary">{label}</p>
        <p className="mt-1 font-mono text-2xl font-bold tabular-nums text-neutral-ink dark:text-white sm:text-3xl">{value}</p>
        {hint ? <p className="mt-1 text-xs text-neutral-secondary">{hint}</p> : null}
    </Card>
);
